import ThemeToggle from "../ThemeToggle";
import "./Footer.css";

function Footer() {
  return (
    <footer className="main-footer">
      <div className="footer-content">
        <p className="footer-attribution">
          Data from{" "}
          <a href="https://phish.in/" target="_blank" rel="noopener noreferrer">
            Phish.in
          </a>{" "}
          (MIT License)
        </p>
        <div className="footer-links">
          <a
            href={`${import.meta.env.VITE_API_BASE_URL}/docs`}
            target="_blank"
            rel="noopener noreferrer"
          >
            API Docs
          </a>
          <ThemeToggle />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
